<template>
  <div v-if="$store.getters['localization/isMaster']" class="wizard-container">
    <base-dialog label="Localization" :is-visible="isInLocalizationMode" @close="endLocalization(true)">
      <template v-slot:form>
        <component :is="component" />
      </template>
    </base-dialog>
  </div>
</template>

<script>
import BaseDialog from '../core/views/dialogs/BaseDialog';
import { mapState } from 'vuex';
import localization from '@/mixins/localization-mixin';
import CopySlides from './forms/copy-slides';
import SelectTargetCountry from './forms/select-target-country';
import ChangeName from './forms/change-name';
import FinishLocalization from './forms/finish-localization';

export default {
  name: 'LocalizationWizard',
  components: {
    FinishLocalization,
    ChangeName,
    SelectTargetCountry,
    CopySlides,

    BaseDialog
  },
  mixins: [localization],
  props: {},
  computed: {
    ...mapState('localization', {
      component: state => state.localization.wizard.current.component,
      isInLocalizationMode: ({ localization }) => localization.isInLocalizationMode
    })
  }
};
</script>

<style scoped></style>
